import React, { useState, useEffect } from 'react';

export default function HelpdeskUser() {
  const [tickets, setTickets] = useState([]);
  const [judul, setJudul] = useState('');
  const [deskripsi, setDeskripsi] = useState('');
  
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [replies, setReplies] = useState([]);
  const [pesanBalasan, setPesanBalasan] = useState('');

  const token = localStorage.getItem('token');
  
  // 1. TAMBAHKAN BASE_URL DI SINI
  const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

  useEffect(() => {
    fetchMyTickets();
  }, []);

  const fetchMyTickets = async () => {
    try {
      // 2. TAMBAHKAN ${BASE_URL} PADA FETCH
      const res = await fetch(`${BASE_URL}/api/helpdesk/my-tickets`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      if (!res.ok) throw new Error("Gagal mengambil data tiket");
      const data = await res.json();
      setTickets(data);
    } catch (err) {
      console.error(err);
    }
  };

  const submitTicket = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(`${BASE_URL}/api/helpdesk`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ judul, deskripsi })
      });
      if (res.ok) {
        alert("Laporan berhasil dikirim!");
        setJudul('');
        setDeskripsi('');
        fetchMyTickets();
      }
    } catch (err) {
      console.error(err);
    }
  };

  const openTicketDetail = async (ticket) => {
    setSelectedTicket(ticket);
    try {
      const res = await fetch(`${BASE_URL}/api/helpdesk/${ticket.id}/replies`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await res.json();
      setReplies(data);
    } catch (err) {
      console.error(err);
    }
  };

  const sendReply = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(`${BASE_URL}/api/helpdesk/${selectedTicket.id}/replies`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ pesan: pesanBalasan })
      });
      if (res.ok) {
        setPesanBalasan('');
        openTicketDetail(selectedTicket);
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-4">Pusat Bantuan (Helpdesk)</h2>

      {!selectedTicket ? (
        <>
          <div className="bg-white p-4 rounded-lg shadow mb-6">
            <h3 className="font-semibold mb-2">Buat Laporan Baru</h3>
            <form onSubmit={submitTicket} className="space-y-3">
              <input 
                type="text" placeholder="Judul Kendala" required
                className="w-full border p-2 rounded"
                value={judul} onChange={(e) => setJudul(e.target.value)}
              />
              <textarea 
                placeholder="Deskripsikan kendala atau bug yang Anda temukan..." required
                className="w-full border p-2 rounded h-24"
                value={deskripsi} onChange={(e) => setDeskripsi(e.target.value)}
              ></textarea>
              <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700">
                Kirim Laporan
              </button>
            </form>
          </div>

          <div className="bg-white rounded-lg shadow overflow-hidden">
            <table className="w-full text-left">
              <thead className="bg-gray-100">
                <tr>
                  <th className="p-3">Tanggal</th>
                  <th className="p-3">Judul Laporan</th>
                  <th className="p-3">Status</th>
                  <th className="p-3">Aksi</th>
                </tr>
              </thead>
              <tbody>
                {tickets.map(t => (
                  <tr key={t.id} className="border-b">
                    <td className="p-3">{new Date(t.created_at).toLocaleDateString('id-ID')}</td>
                    <td className="p-3">{t.judul}</td>
                    <td className="p-3">
                      <span className={`px-2 py-1 rounded text-sm ${t.status === 'Open' ? 'bg-yellow-200' : t.status === 'Resolved' ? 'bg-green-200' : 'bg-blue-200'}`}>
                        {t.status}
                      </span>
                    </td>
                    <td className="p-3">
                      <button onClick={() => openTicketDetail(t)} className="text-blue-600 underline">Lihat Detail</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      ) : (
        <div className="bg-white p-6 rounded-lg shadow">
          <button onClick={() => setSelectedTicket(null)} className="mb-4 text-gray-500 hover:text-black">
            &larr; Kembali ke Daftar
          </button>
          <div className="border-b pb-4 mb-4">
            <h3 className="text-xl font-bold">{selectedTicket.judul}</h3>
            <p className="text-gray-600 mt-2">{selectedTicket.deskripsi}</p>
          </div>

          <div className="space-y-4 mb-4 max-h-96 overflow-y-auto bg-gray-50 p-4 rounded">
            {replies.length === 0 ? <p className="text-gray-400 text-center">Belum ada balasan.</p> : null}
            {replies.map(r => (
              <div key={r.id} className={`p-3 rounded-lg max-w-[80%] ${r.role === 'admin' ? 'bg-blue-100 ml-auto' : 'bg-white border'}`}>
                <p className="text-xs text-gray-500 font-semibold">{r.pengirim} ({r.role})</p>
                <p>{r.pesan}</p>
              </div>
            ))}
          </div>

          <form onSubmit={sendReply} className="flex gap-2">
            <input 
              type="text" placeholder="Ketik pesan balasan..." required
              className="flex-1 border p-2 rounded"
              value={pesanBalasan} onChange={(e) => setPesanBalasan(e.target.value)}
            />
            <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded">Kirim</button>
          </form>
        </div>
      )}
    </div>
  );
}